import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventosGenericosComponent } from './eventos-genericos/eventos-genericos.component';
// Sirena-specific route removed: mostrar solo el listado generico 'Vivos'

const routes: Routes = [
  {
    path: '',
    title: 'Eventos',
    component: EventosGenericosComponent,
    canActivate: [],
  },
  // sirena route removed
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EventosGenericosRoutingModule {}
